import { t } from 'typy'

export function isNullOrEmptyStr (v) {
    return t(v).isEmptyString || t(v).isNull
}
